import {
  changeThemePaletteRequest,
  changeThemePaletteSuccess,
} from "../actions/theme";
import { getDefaultPalette, setPalette } from "./utils";

export interface authState {
  palette: {};
  gradient: string;
}
export const getInitialState = () => {
  const cachePalette = getWithExpiry("palette");
  const cacheGradient = getWithExpiry("gradient");
  return {
    palette: cachePalette
      ? setPalette(JSON.parse(cachePalette))
      : getDefaultPalette,
    gradient: cacheGradient
      ? JSON.parse(cacheGradient) && JSON.parse(cacheGradient).style
      : "linear-gradient(269.93deg, rgb(95, 162, 155) -2.15%, rgb(66, 114, 169) 84.21%, rgb(24, 59, 105) 116.28%)",
  };
};

const themeReducer = (state: authState = getInitialState(), action: any) => {
  switch (action.type) {
    case changeThemePaletteRequest:
      return { ...state, isAdminUserChecking: true };
    case changeThemePaletteSuccess:
      const settings = action.palette;
      const palette = JSON.parse(settings.colorPalette);
      const gradient = JSON.parse(settings.gradient);
      const ttl = 24 * 3600000; // 1 day
      setWithExpiry("palette", settings.colorPalette, ttl);
      setWithExpiry("gradient", settings.gradient, ttl);
      return {
        ...state,
        palette: setPalette(palette),
        gradient: gradient && gradient.style,
      };
    default:
      return state;
  }
};

export default themeReducer;

const setWithExpiry = (key: string, value: string, ttl: number) => {
  const now = new Date();
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

const getWithExpiry = (key: string) => {
  const itemStr = localStorage.getItem(key);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};
